import moment from 'moment';

const insertHyphon = (target, index) => `${target.slice(0, index)}-${target.slice(index)}`;

const corporateNumber = (corporateId) => {
  if (!corporateId) {
    return '';
  }
  let result = corporateId.slice(1);
  result = insertHyphon(result, 6);
  result = insertHyphon(result, 4);
  return result;
}

const money = (value) => {
  const num = String(value);
  let result = '';
  const nums = num.split('');
  const len = nums.length;
  if (len <= 3) {
    return num;
  }
  for (let i = 0; i < len; i += 1) {
    result = nums[(len - 1) - i] + result;
    if (i % 3 === 2 && i !== len - 1) {
      result = `,${result}`;
    }
  }
  return result;
}

const date = (value) => moment(value).format('YYYY/MM/DD HH:mm');

// eslint-disable-next-line import/no-anonymous-default-export
export default {corporateNumber, money, date};